import type { IQueueEvent } from "../store/types";
import { dataTitles } from "./lookups/dataTitles";
import { dataUnits } from "./lookups/dataUnits";

interface IDirtyTile {
  keyName: string;
  title: string;
  units: string;
  value: number | string;
}

interface ICleanTile {
  keyName: string;
  title: string;
  units: string;
  value: number | string;
}

export const eventCleaner = (eventData: IQueueEvent): ICleanTile[] => {
  let allData: ICleanTile[] = [];

  if (eventData.pitch_data) {
    let pitchData = extractData(eventData.pitch_data);
    pitchData = removeUnwantedElements(
      pitchData,
      new Set([
        "eventReconstruction",
        "ExtensionAccurate",
        "ZoneAccuracy",
        "ReleaseAccuracy",
        "yt_R0",
        "yt_AeroModel",
      ]),
    );
    const cleanedPitchData = cleanData(pitchData, "Tilt");
    allData = [...allData, ...cleanedPitchData];
  }

  if (eventData.hit_data) {
    let hitData = extractData(eventData.hit_data);
    hitData = removeUnwantedElements(
      hitData,
      new Set(["GroundAccuracy", "yt_R0", "ExitAccuracy", "yt_AeroModel"]),
    );
    const cleanedHitData = cleanData(hitData);
    allData = [...allData, ...cleanedHitData];
  }

  return allData;
};

const extractData = (
  rawData: Record<string, number | string>,
): IDirtyTile[] => {
  return Object.entries(rawData).map(([key, value]) => ({
    keyName: key,
    title: dataTitles[key],
    units: dataUnits[key],
    value,
  }));
};

const removeUnwantedElements = (
  data: IDirtyTile[],
  unwantedKeys: Set<string>,
): IDirtyTile[] => {
  return data.filter(({ keyName }) => !unwantedKeys.has(keyName));
};

const cleanData = (data: IDirtyTile[], isolateKey?: string): ICleanTile[] => {
  let isolateData: IDirtyTile | null = null;
  if (isolateKey) {
    data = data.filter((item) => {
      if (item.keyName === isolateKey) {
        isolateData = item;
        return false;
      }
      return true;
    });
  }

  const cleanedData = data.map(({ keyName, title, units, value }) => ({
    keyName,
    title,
    units,
    value: typeof value === "number" ? parseFloat(value.toFixed(1)) : 0,
  }));

  return isolateData ? [...cleanedData, isolateData] : cleanedData;
};
